import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "../styles.module.css"; // We'll store updated CSS here
import warning from "antd/es/_util/warning";

const AddAssessmentType = () => {
  // Form states
  const [assessmentName, setAssessmentName] = useState("");
  const [loading, setLoading] = useState(false);

  // Popup states
  const [popupMessage, setPopupMessage] = useState(null);
  const [popupType, setPopupType] = useState(""); // "success" or "error"

  // Table states for assessment types
  const [assessmentTypes, setAssessmentTypes] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableError, setTableError] = useState("");

  // Fetch existing assessment types on mount
  useEffect(() => {
    fetchAssessmentTypes();
  }, []);

  const fetchAssessmentTypes = async () => {
    setTableLoading(true);
    setTableError("");

    try {
      // Make the POST request with empty body
      const response = await axios.post("https://casaahaanahotels.com/get_master_assessment_type", {});

      if (response.data && Array.isArray(response.data)) {
        setAssessmentTypes(response.data);
      } else {
        setTableError("No assessment types found.");
      }
    } catch (error) {
      setTableError(`Error fetching assessment types: ${error.message}`);
    } finally {
      setTableLoading(false);
    }
  };

  const handleAddAssessmentType = async () => {
    if (!assessmentName.trim()) {
      setPopupMessage("Assessment Name is required.");
      setPopupType("error");
      return;
    }

    setPopupMessage(null);
    setLoading(true);

    try {
      const companyId = localStorage.getItem("companyId");
      const response = await axios.post("https://casaahaanahotels.com/add_master_assessment_type", {
        CompanyId: companyId,
        AssessmentType: assessmentName,
      });

      const result = response.data.response?.result;
      if (result === "created") {
        setPopupMessage("Assessment type added successfully.");
        setPopupType("success");
        setAssessmentName("");

        // Refresh table after adding a new assessment
        fetchAssessmentTypes();
      } else {
        setPopupMessage("Failed to add assessment type. Please try again.");
        setPopupType("error");
      }
    } catch (error) {
     
      setPopupMessage("Assessment type already exists.");
      setPopupType("error");
    } finally {
      setLoading(false);
    }
  };

  const closePopup = () => {
    setPopupMessage(null);
  };

  return (
    <div className={styles.pageContainer}>
      {/* Form Container */}
      <div className={styles.formContainer}>
        <h2 className={styles.formTitle}>Add Assessment Type</h2>
        <form className={styles.assignForm}>
          {/* Assessment Name */}
          <div className={styles.formRow}>
            <label className={styles.formLabel}>Assessment Name:</label>
            <input
              type="text"
              value={assessmentName}
              onChange={(e) => setAssessmentName(e.target.value)}
              placeholder="Enter assessment name"
              className={styles.textField}
            />
          </div>

          {/* Button */}
          <div className={styles.buttonContainer}>
            <button
              type="button"
              onClick={handleAddAssessmentType}
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Assessment Type"}
            </button>
          </div>
        </form>

        {/* Popup Message */}
        {popupMessage && (
          <div
            className={
              popupType === "success"
                ? styles.successMessage
                : styles.errorMessage
            }
          >
            {popupMessage}
            <button onClick={closePopup} className={styles.closeButton}>
              &times;
            </button>
          </div>
        )}
      </div>

      {/* Table Container */}
      <div className={styles.tableContainer}>
        <h2 className={styles.tableTitle}>Existing Assessment Types</h2>
        {tableLoading ? (
          <p>Loading assessment types...</p>
        ) : tableError ? (
          <p className={styles.errorMessage}>{tableError}</p>
        ) : assessmentTypes.length === 0 ? (
          <p>No assessment types found.</p>
        ) : (
          <table className={styles.companiesTable}>
            <thead>
              <tr>
                <th>Assessment Type</th>
              </tr>
            </thead>
            <tbody>
              {assessmentTypes.map((item, index) => (
                <tr key={index}>
                  <td>{item.AssessmentType || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AddAssessmentType;
